export const sectionContentMaxWidth = 1312;
